/**
 * Author: Andrey Morozov
 * Confidential. Proprietary code. Do not distribute without authorization.
 *
 * parseEnvelope.ts — pars\1 \2nvelope (services/operator-web-app).
 */

import type { BaseEnvelope, ServerEnvelope } from './types';

/**
 * Minimal envelope shape check (aligned with ws-operator-events.schema.json BaseFrame).
 * Use before applying to store to avoid malformed data.
 */
function hasRequiredEnvelopeFields(obj: unknown): obj is BaseEnvelope {
  if (obj == null || typeof obj !== 'object') return false;
  const o = obj as Record<string, unknown>;
  return (
    typeof o.version === 'string' &&
    typeof o.direction === 'string' &&
    typeof o.event_type === 'string' &&
    typeof o.event_id === 'string' &&
    typeof o.occurred_at === 'string' &&
    typeof o.sequence === 'number' &&
    o.payload != null &&
    typeof o.payload === 'object'
  );
}

export function isServerEnvelope(obj: unknown): obj is ServerEnvelope {
  return hasRequiredEnvelopeFields(obj) && (obj as BaseEnvelope).direction === 'server_to_client';
}

/**
 * Parse JSON and return ServerEnvelope or null if invalid.
 */
export function parseServerEnvelope(raw: string): ServerEnvelope | null {
  try {
    const data = JSON.parse(raw) as unknown;
    return isServerEnvelope(data) ? data : null;
  } catch {
    return null;
  }
}
